import styled, { css } from 'styled-components';
import { mediaBreakpointMixin, Menu, ModalDialog, Popover, TextButton, token } from '@zillow/constellation';

export const menuMaxHeight = 350;
export const menuContentBodyMaxHeight = 230;

export const StyledIconContainer = styled(TextButton)`
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  position: relative;
  color: unset;

  &&:hover {
    cursor: pointer;
  }
`;

/**
 * TODO: come up with a better solution
 * alert icon has spacing and alignment issues with the other
 * navigation items for the horizontal layout
 *
 * this styled component serves as a workaround to align the nav item and link label
 */
export const StyledIconBellOutlineContainer = styled.div`
  width: 24px;
  height: 24px;
  margin-right: -4px;
  overflow: visible;
`;

export const StyledNotificationCircle = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;
  top: -1px;
  right: -2px;
  border-radius: 50%;
  background: ${token('colors.orange400')};
  color: white;
`;

export const StyledMenu = styled(Menu)`
  max-height: ${menuMaxHeight}px;
  overflow-y: scroll;

  && {
    margin-top: 5px;
  }
`;

export const StyledPopover = styled(Popover)`
  && [class^='DialogBody'] {
    padding-left: 0;
    padding-right: 0;
    overflow: hidden;
  }
`;

interface BodyContentProps {
  disableMaxHeight?: boolean;
}

export const StyledMenuContentBody = styled.div<BodyContentProps>`
  padding: 0;
  max-height: ${(props) => (props.disableMaxHeight ? 'max-content' : `${menuContentBodyMaxHeight}px`)};
  overflow-y: auto;
`;

export const StyledMenuContentFooter = styled.div`
  border-top: 1px solid #f1f1f4;
`;

export const StyledCloseButton = styled.div`
  display: none;
`;

export const StyledNoUnderlineTextButton = styled(TextButton)`
  &&:hover {
    text-decoration: none;
  }
`;

const mobileStyles = css`
  display: block;

  /* 1025 */
  @media ${mediaBreakpointMixin('xl')} {
    display: none;
  }
`;

export const StyledMobileDisplay = styled.div`
  ${mobileStyles}
`;

export const StyledModalDialog = styled(ModalDialog)`
  ${mobileStyles}
`;

export const StyledDesktopDisplay = styled.div`
  display: none;

  /* 1025 */
  @media ${mediaBreakpointMixin('xl')} {
    display: block;
  }
`;
